module.exports = __webpack_public_path__ + "img/web_before.4bc9cecc.png";